module.exports = __webpack_public_path__ + "img/bg3_icon.db03ff47.jpg";